import { createPinia } from 'pinia';
export { storeToRefs } from 'pinia';
export * from './account';
export * from './menu';
export * from './setting';

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate' // 引入数据持久化插件

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate)

export default pinia;
